// extracted by mini-css-extract-plugin
export var border = "PromotionCardImageTop-module--border--b4ce7";
export var promocardimage = "PromotionCardImageTop-module--promocardimage--3a785";
export var promocardimagecontainer = "PromotionCardImageTop-module--promocardimagecontainer--13137";
export var promocardtext = "PromotionCardImageTop-module--promocardtext--d3ab6";
export var promocardtextcontainer = "PromotionCardImageTop-module--promocardtextcontainer--541d7";
export var promocardwrapper = "PromotionCardImageTop-module--promocardwrapper--a01a9";
export var promocardwrapperdoglisting = "PromotionCardImageTop-module--promocardwrapperdoglisting--b2606";
export var title = "PromotionCardImageTop-module--title--75a37 headings-module--signpostHeading--5d377";